var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReaderMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_2779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2498 3.66663H2.74984C1.7415 3.66663 0.916504 4.49163 0.916504 5.49996V17.4166C0.916504 18.425 1.7415 19.25 2.74984 19.25H19.2498C20.2582 19.25 21.0832 18.425 21.0832 17.4166V5.49996C21.0832 4.49163 20.2582 3.66663 19.2498 3.66663ZM2.74984 17.4166V5.49996H10.0832V17.4166H2.74984ZM19.2498 17.4166H11.9165V5.49996H19.2498V17.4166ZM12.8332 8.70829H18.3332V10.0833H12.8332V8.70829ZM12.8332 11H18.3332V12.375H12.8332V11ZM12.8332 13.2916H18.3332V14.6666H12.8332V13.2916Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_2779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaderMode);
export default __webpack_public_path__ + "static/media/reader-mode.f174f56b3ab6237fe7735c084bed7a73.svg";
export { ForwardRef as ReactComponent };